import {
  FilterValue,
  SelectFilter,
  SelectOption,
  StringFilterValue,
} from "../../types/filter";
import { TrackingProps } from "../../types/component";
import { PillSelect } from "../FilterPill/PillSelect";
import {
  getSelectedFilterValue,
  updatedFilterValueFromValues,
} from "../../utils/filter/filtervalue";
import { createFilterValueFromSelectOption } from "../../utils/filter/selectfiltervalue";

interface InputSelectPillDesktopProps {
  filter: SelectFilter;
  filterValues: FilterValue[];
  setFilterValues: (filterValues: FilterValue[]) => void;
  onTriggerFilter: (filterId: string) => void;
  tracking: TrackingProps;
}

export const InputSelectPillDesktop = ({
  filter,
  filterValues,
  setFilterValues,
  onTriggerFilter,
  tracking,
}: InputSelectPillDesktopProps) => {
  const { id, defaultValue } = filter;
  const filterValue = getSelectedFilterValue(
    id,
    filterValues,
    defaultValue
  ) as StringFilterValue;
  const handleOnChange = (option: SelectOption) => {
    const value = createFilterValueFromSelectOption(filter.id, option);
    setFilterValues(updatedFilterValueFromValues(filterValues, filter, value));
  };

  return (
    <PillSelect
      tracking={tracking}
      filter={filter}
      filterValue={filterValue}
      selected={filterValue}
      onChange={handleOnChange}
      onTriggerFilter={onTriggerFilter}
    />
  );
};
